import { queryOptions } from '@tanstack/react-query';

import { ONE_MINUTE } from '@/constants/time';
import { paths } from '@/types/api';
import { fetchClient } from '@/util/fetchClient';

type GetInquiryV2Params = paths['/v2/inquiries/{conversationId}']['get']['parameters']['path'];

export type GetInquiryV2Response =
  paths['/v2/inquiries/{conversationId}']['get']['responses'][200]['content']['application/json']['data'];

export type GetInquiryV2ResponseExpert = NonNullable<
  paths['/v2/inquiries/{conversationId}']['get']['responses'][200]['content']['application/json']['data']
>['recipient'];

/** A single entry from the `groupInquiries` array on the single-inquiry endpoint. */
export type GetInquiryV2GroupMember = NonNullable<GetInquiryV2Response>['groupInquiries'][0];

export async function getInquiryV2({ conversationId }: GetInquiryV2Params) {
  const { data } = await fetchClient.GET('/v2/inquiries/{conversationId}', {
    params: {
      path: { conversationId },
    },
  });

  return data?.data;
}

export function getInquiryV2QueryOptions({ conversationId }: GetInquiryV2Params) {
  return queryOptions({
    queryKey: ['inquiriesV2', conversationId],
    queryFn: () => getInquiryV2({ conversationId }),
    staleTime: ONE_MINUTE,
    gcTime: ONE_MINUTE,
  });
}
